import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ClassLeaderTimerView from "./ClassLeaderTimerView";
import apiCall from "../apiCall";

class ClassLeaderTimerController extends Component {
  static propTypes = {
    schoolClassId: PropTypes.number.isRequired,
    timerPausedAt: PropTypes.any,
    timerEndsAt: PropTypes.any,
  };

  static defaultProps = {
    timerPausedAt: null,
    timerEndsAt: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      minDouble: 0,
      minSingle: 0,
      secDouble: 0,
      secSingle: 0,
      timerEndsAt: null,
      timerPausedAt: null,
      isRunning: false,
      serverDelayMs: 0,
    };

    this.lastTimerFrame = 0;
    this.timeDifferenceMs = 0;

    this.timerFrame = false;
  }

  componentWillMount = async () => {
    this.setState({
      serverDelayMs: await this.getTimeDifferenceInMs(),
    });
  };

  componentDidMount = () => {
    const {timerEndsAt, timerPausedAt} = this.props;
    if(timerPausedAt !== null && timerEndsAt !== null) {
      //Timer is paused but set
      this.setState({
        isRunning: false,
        timerEndsAt: new Date(timerEndsAt),
        timerPausedAt: new Date(timerPausedAt),
      }, () => {
        this.setTimerDigits();
      })

    } else if(timerPausedAt === null && timerEndsAt !== null) {
      //Timer is running
      this.setState({
        isRunning: true,
        timerEndsAt: new Date(timerEndsAt)
      }, () => {
        this.timerFrame = requestAnimationFrame(this.countdown);
      })
    } else if(timerPausedAt !== null && timerEndsAt === null) {
      //Something has gone wrong at some point, reset the timer.
      this.saveTimerCleared();
    }
  }

  saveTimerPaused = () => {
    const { schoolClassId } = this.props;
    const { timerPausedAt } = this.state;
    apiCall(`/schoolClass/${schoolClassId}/setTimer`, { timerPausedAt }, 'PUT');
  }

  saveTimerEndsAt = () => {
    const { schoolClassId } = this.props;
    const { timerEndsAt } = this.state;
    apiCall(`/schoolClass/${schoolClassId}/setTimer`, { timerEndsAt, timerPausedAt: null }, 'PUT');
  }

  saveTimerCleared = () => {
    const { schoolClassId } = this.props;
    apiCall(`/schoolClass/${schoolClassId}/setTimer`, { timerEndsAt: null, timerPausedAt: null }, 'PUT');
  }

  getTimeDifferenceInMs = async () => {
    const res = await apiCall('/define/time');
    if(res) {
      return (new Date(res.time)).getTime() - (new Date()).getTime();
    }
    return 0;
  }

  assertValue = (val, key, confirmed) => {
    if((!confirmed && val < 10 && val >= 0) || val === "") return true;

    switch (key) {
      case "minDouble":
      case "minSingle":
      case "secSingle":
        return val < 10 && val >= 0;
      case "secDouble":
        return val  < 6 && val >= 0;
      default:
        return false;
    }
  };

  handleInputChange = (e, key, confirmed) => {
    let { value: val } = e.target;
    if (val === '') {
      this.setState({ [key]: this.state[key] });
      return;
    }
    val = parseInt(val, 10);
    if (val === this.state[key]) return;
    if (isNaN(val)) {
      val = this.state[key];
    }
    // Parsed the value or stored empty string when empty.
    let parsedValue = parseInt(val, 10) || "";

    // Checks if value is valid
    if(!this.assertValue(parsedValue, key, confirmed)) return;
    if(val === 0) return;
    // If confirmed and value is string it is changed to a 0
    if(confirmed && val.trim() === "") parsedValue = 0;

    // Saves the value
    this.setState({ [key]: parsedValue });
  }

  handleClearTimer = () => {
    cancelAnimationFrame(this.timerFrame);
    this.setState({
      isRunning: false,
      timerEndsAt: null,
      timerPausedAt: null,
      minDouble: 0,
      minSingle: 0,
      secDouble: 0,
      secSingle: 0,
    }, () => {
      this.saveTimerCleared();
    })
  }

  calculateTimeInMs
    = () => {
    // Calculates the inserted time in miliseconds
    if(this.state.timerPausedAt && this.state.timerEndsAt) {
      const duration = Math.abs(this.state.timerPausedAt.getTime() - this.state.timerEndsAt.getTime());
      return duration;
    }
    let miliseconds = 0;
    miliseconds += (this.state.secSingle + this.state.secDouble * 10) * 1000;
    miliseconds += (this.state.minSingle + this.state.minDouble * 10) * 60000;
    return miliseconds;
  }

  setTimerDigits = () => {
    const {timerEndsAt} = this.state;
    if(!timerEndsAt) return;
    const endsInMs = timerEndsAt.getTime();
    const remaining = endsInMs - (this.state.timerPausedAt ? this.state.timerPausedAt : Date.now() + this.state.serverDelayMs);
    if (!isNaN(remaining)) {
      if (remaining <= 1000) {
        return this.handleClearTimer();
      }
      const remainingTimeStamp = new Date(remaining);
      const minutes = (((remainingTimeStamp.getHours() - 1) / 60) + remainingTimeStamp.getMinutes()) + "";
      const seconds = remainingTimeStamp.getSeconds() + "";
      this.setState({
        minDouble: parseInt((minutes.length > 1 ? minutes[0] : 0), 10),
        minSingle: parseInt((minutes.length > 1 ? minutes[1] : minutes), 10),
        secDouble: parseInt((seconds.length > 1 ? seconds[0] : 0), 10),
        secSingle: parseInt((seconds.length > 1 ? seconds[1] : seconds), 10),
      });
    }
  }

  countdown = (timestamp) => {
    if (!this.lastTimerFrame) {
      this.lastTimerFrame = timestamp
    }
    if (timestamp - this.lastTimerFrame >= 100) { // every 100 ms
      this.setTimerDigits();

      this.lastTimerFrame = timestamp;
    }
    if(this.state.isRunning) {
      this.timerFrame = requestAnimationFrame(this.countdown);
    } else {
      cancelAnimationFrame(this.timerFrame);
    }
  }


  handleRunningToggle = () => {
    //Timer is not running
    if(!this.state.isRunning) {
      this.setState({ timerPausedAt: false }, () => {
        const timerDuration = this.calculateTimeInMs();
        const timerEndsAt = new Date(Date.now() + timerDuration + this.state.serverDelayMs);
        this.setState({
          isRunning: true,
          timerEndsAt,
          timerPausedAt: null,
        }, () => {
          this.saveTimerEndsAt();
          this.timerFrame = requestAnimationFrame(this.countdown);
        })
      });
    } else {
      cancelAnimationFrame(this.timerFrame);
      this.setState({
        isRunning: false,
        timerPausedAt: new Date(),
      }, () => {
        this.saveTimerPaused()
      })
    }
  }

  render() {
    return <ClassLeaderTimerView
            handleInput={(e, key, confirmed) => this.handleInputChange(e, key, confirmed)}
            handleRunningToggle={() => this.handleRunningToggle()}
            handleClearTimer={() => this.handleClearTimer()}
            minDouble={this.state.minDouble}
            minSingle={this.state.minSingle}
            secDouble={this.state.secDouble}
            secSingle={this.state.secSingle}
            isRunning={this.state.isRunning}
            toggleFlipCountDownDropdown={this.props.toggleFlipCountDownDropdown}
            />
  }
}

export default ClassLeaderTimerController;



// WEBPACK FOOTER //
// ./src/components/elements/ClassLeaderTimerController.js